(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fw-journal-index"] && !Shopify.designMode) return;
  try {
    
(() => {
  const revealStory = () => {
    const id = window.location.hash.slice(1);
    const story = document.getElementById(id);
    if (story && story.matches('.fw-journal-story')) story.open = true;
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('.fw-journal-topics a[href^="#"]');
    if (!link) return;
    const story = document.getElementById(link.getAttribute('href').slice(1));
    if (story && story.matches('.fw-journal-story')) story.open = true;
  });
  window.addEventListener('hashchange', revealStory);
  document.addEventListener('shopify:section:load', revealStory);
  revealStory();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
if (!window.fwMegaBound) {
  window.fwMegaBound = true;
  const desktopHover = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  const closeTimers = new WeakMap();
  document.addEventListener('pointerover', (event) => {
    if (!desktopHover.matches || event.pointerType === 'touch') return;
    const menu = event.target.closest('[data-fw-mega]');
    if (!menu) return;
    clearTimeout(closeTimers.get(menu));
    if (!menu.contains(event.relatedTarget)) menu.open = true;
  });
  document.addEventListener('pointerout', (event) => {
    if (!desktopHover.matches || event.pointerType === 'touch') return;
    const menu = event.target.closest('[data-fw-mega]');
    if (!menu || menu.contains(event.relatedTarget)) return;
    clearTimeout(closeTimers.get(menu));
    closeTimers.set(menu, setTimeout(() => {
      if (!menu.querySelector(':focus-visible')) menu.open = false;
    }, 180));
  });
  document.addEventListener('click', (event) => {
    const summary = event.target.closest('[data-fw-mega] > summary');
    if (summary && desktopHover.matches && event.pointerType !== 'touch' && event.detail > 0) {
      event.preventDefault();
      summary.parentElement.open = true;
    }
    document.querySelectorAll('[data-fw-mega][open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-fw-mega][open]').forEach((menu) => {
      menu.open = false;
      menu.querySelector('summary').focus();
    });
  });
  document.addEventListener('focusin', (event) => {
    document.querySelectorAll('[data-fw-mega][open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
}

  } catch(e) { console.error(e); }
})();
})();
